const enCode = (str = '') => {
  return encodeURIComponent(str);
};
const deCode = (str) => {
  return decodeURIComponent(str);
};

export { enCode, deCode };
